
import "D:/projects/sxzx/fs-sxzx-web/src/components/RightContent/index.less?modules";
export default {"account": `account-mSx9YWuV`,"userIcon": `userIcon-MENDZfg3`,"search": `search-HysosEqr`,"avatar": `avatar-uJPhv_s2`,"menu": `menu-k1C14_1W`,"right": `right-YnA478Gf`,"action": `action-n_l9NWMb`,"name": `name-IYutffLu`}
